import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';
import sizeStandards from '../../../Style-guide/size-standards';

const SignUpWrapper = styled.section`
  .page-title,
  .have-account-text {
    text-align: center;
  }

  .container {
    display: flex;
    justify-content: center;
    padding: 20px;

    form {
      display: flex;
      justify-content: space-between;
      @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
        flex-direction: column;
      }

      .fields-container {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 8px;

        label {
          margin: 12px 32px;
          max-width: 320px;
          width: 100%;

          @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
            margin: 10px 0;
          }
        }
      }

      .submit-btn {
        padding: 9px;
        position: absolute;
        top: 242px;
        max-width: 100px;
        width: 100%;

        @media only screen and (max-width: ${sizeStandards.screen.LG}px) {
          top: 235px;
        }

        @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
          position: unset;
          margin-top: 32px !important;
        }
      }
    }
  }

  .have-account-text {
    margin-bottom: 7vh;

    @media only screen and (max-width: ${sizeStandards.screen.XL}px) {
      margin-bottom: 11vh;
    }

    @media only screen and (max-width: ${sizeStandards.screen.LG}px) {
      margin-bottom: 14vh;
    }

    .link-to-sign-in {
      margin-left: 8px;
      text-decoration: none;
      color: ${mainColors.text_color};

      &:hover {
        color: ${mainColors.main_color};
      }
    }
  }

  .verification-modal {
    .modal-content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .close-button {
      display: none;
    }
    .verification-title {
      text-align: center;
      max-width: 300px;
    }
    .submit-btn {
      margin-top: 12px;
    }
  }
`;

export default SignUpWrapper;
